<!--
 * @Descripttion: 
 * @FilePath: /mall-wap-vue/src/App.vue
 * @Author: 张兴业
 * @Date: 2020-09-24 10:19:31
 * @LastEditors: hl
 * @LastEditTime: 2024-11-26 17:40:17
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { changeFavicon, configTitle } from "@/global";
export default {
  mounted() {
    changeFavicon();
    configTitle();
  },
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f6f7f8;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
